import React, { Component } from 'react';
import { auth } from '../firebase';
import { List, Card, Button } from "antd";
import {
  Link,
} from 'react-router-dom'


class AdminDash extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    }

  }
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ email: user.email })
      }
    });
  }


  render() {
    return (
      <div>
        <h1>Admin Dashboard {this.state.email}</h1>
        <br></br>
        <Card className="cardy" title="Check integrity, import/export">
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/test/events/'>eventmedia</Link>
          </Button>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/test/events/'>events</Link>
          </Button>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/test/events/'>limited</Link>
          </Button>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/test/events/'>lunits</Link>
          </Button>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/test/events/'>project</Link>
          </Button>
          <Button className="gutter-box" type="secondary" size="large" >
            <Link to='/admin/units/'>units</Link>
          </Button>
          <br />
        </Card>
        <Card className="cardy">
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/dashboard/projects/'>Check storage and database intergrity</Link>
          </Button>
          <br />
        </Card>
        <br></br>
      </div>
    );

  }

}

export default AdminDash;



// WEBPACK FOOTER //
// ./src/tests/admindash.js